import { setSettings } from "store/features/memeGenerator/actions";
import { TextBoxStates } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useKeyboard = (textBoxId: string) => {
    const dispatch = useAppDispatch();
    function handleClick() {
        dispatch(
            setSettings({
                id: textBoxId,
                state: TextBoxStates.INSERT,
            }),
        );
    }
    return { handleClick };
};
